import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container card w-auto mx-auto px-20 py-20 text-center border-2 mt-20"
}
const _hoisted_2 = { class: "title text-xl font-bold text-green-400" }
const _hoisted_3 = { class: "text-lg" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Reference:", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-bold mt-4" }, "Amount Paid:", -1)
const _hoisted_6 = { class: "font-bold text-2xl" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "block px-7 py-1 text-sm font-medium bg-white rounded-full hover:bg-transparent" }, " Return to Profile ", -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "container card w-auto mx-auto px-20 py-20 text-center border-2 mt-20"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h1", { class: "title text-xl font-bold text-green-400" }, " Verifying Payment Status.... ", -1)
const _hoisted_12 = {
  key: 0,
  class: "text-gray-500 mt-2"
}

import router from "@/router/index";
import { StripeService } from "@/services/StripeService";
import { HoodApi } from "@/services/HoodApi";
import { useAuthStore } from "@/stores/auth";
import { ref, computed, onUnmounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const auth = useAuthStore();
const secret = router.currentRoute.value.query.payment_intent_client_secret;
const intent = router.currentRoute.value.query.payment_intent;
const ready = ref(false);
const verifying = ref(true);
const status = ref<any>({});
const my_status = computed(() => status.value);

let pollInterval: ReturnType<typeof setInterval> | null = null;

const verifyPayment = async () => {
  // First, get the payment status from Stripe directly
  const info = await StripeService.get_payment_status(String(secret));
  status.value = info.paymentIntent;

  if (info.paymentIntent.status === "succeeded") {
    // Payment succeeded on Stripe side
    // Now poll the backend to confirm the webhook has processed it
    await pollForPaymentRecord(String(intent));
  } else {
    // Payment not yet succeeded - show the status anyway
    ready.value = true;
    verifying.value = false;
  }
};

const pollForPaymentRecord = async (paymentIntentId: string) => {
  let attempts = 0;
  const maxAttempts = 20; // 20 attempts * 1.5 seconds = 30 seconds max

  const checkPayment = async () => {
    attempts++;
    try {
      // Check if the backend has the payment record with succeeded status
      const payments = await HoodApi.get_payment_by_stripe_ref(paymentIntentId);

      if (payments && payments.length > 0) {
        const payment = payments[0];
        if (payment.status === "succeeded") {
          // Webhook has processed it - we're done
          if (pollInterval) {
            clearInterval(pollInterval);
            pollInterval = null;
          }
          // Refresh user data so profile shows updated payments
          await auth.fetch_user_data();
          ready.value = true;
          verifying.value = false;
          return;
        }
      }

      // If we've exceeded max attempts, show success anyway
      // (Stripe confirmed it, webhook might just be slow)
      if (attempts >= maxAttempts) {
        if (pollInterval) {
          clearInterval(pollInterval);
          pollInterval = null;
        }
        await auth.fetch_user_data();
        ready.value = true;
        verifying.value = false;
      }
    } catch (e) {
      console.log("Error polling for payment:", e);
      // On error, if we have Stripe confirmation, show success
      if (attempts >= maxAttempts) {
        if (pollInterval) {
          clearInterval(pollInterval);
          pollInterval = null;
        }
        ready.value = true;
        verifying.value = false;
      }
    }
  };

  // Initial check
  await checkPayment();

  // If not ready yet, start polling
  if (!ready.value) {
    pollInterval = setInterval(checkPayment, 1500);
  }
};

const toProfile = () => {
  router.push({ name: "profile" });
};

// Cleanup on unmount
onUnmounted(() => {
  if (pollInterval) {
    clearInterval(pollInterval);
  }
});

// Start verification
verifyPayment();

return (_ctx: any,_cache: any) => {
  return (ready.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, " Payment " + _toDisplayString(_unref(my_status).status), 1),
        _createElementVNode("h1", _hoisted_3, [
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_unref(my_status).id), 1)
        ]),
        _hoisted_5,
        _createElementVNode("p", _hoisted_6, "$" + _toDisplayString((_unref(my_status).amount / 100).toFixed(2)), 1),
        _hoisted_7,
        _createElementVNode("button", {
          onClick: toProfile,
          class: "mt-8 p-[2px] rounded-full bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 hover:text-white active:text-opacity-75 focus:outline-none focus:ring"
        }, _hoisted_9)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_10, [
        _hoisted_11,
        (verifying.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_12, " Please wait while we confirm your payment. "))
          : _createCommentVNode("", true)
      ]))
}
}

})